export const colors = {
    purple: '#7F56D9',
    darkGrey: '#344054',
    darkGrey2: '#F8F9F8',
    grey: '#5D6B98',
    lightGrey: '#B9C0D4',
    green: '#079455'
};

export const fonts = {
    fontFamily: "Inter, sans-serif",
    bold: {
        size: '16px',
        lineHeight: '24px',
        color: colors.darkGrey,
        fontWeight: 500
    },
    default: {
        size: '13px',
        lineHeight: '13px',
        color: colors.darkGrey,
        fontWeight: 400
    },
    informative: {
        size: '11px',
        lineHeight: '11px',
        color: colors.darkGrey,
        fontWeight: 400
    }
};
